<template>
  <md-dialog class="create-circle-dialog" :md-active.sync="internalVisible">
    <md-dialog-title>Add {{ label }} <span class="minimum">(Minimum {{ minLength }} characters)</span></md-dialog-title>
    <md-dialog-content>
      <md-field>
        <label>{{ label }}</label>
        <md-input
          v-if="dialogType === 'subject'"
          v-model="value"
          :placeholder="`Enter a new ${label.toLowerCase()}`"
          :maxlength="maxLength"
          :md-counter="maxLength"
        />
        <md-textarea
          v-else
          v-model="value"
          :placeholder="`Enter a new ${label.toLowerCase()}`"
          :maxlength="maxLength"
          :md-counter="maxLength"
          rows="5"
        />
      </md-field>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button @click="cancel">Cancel</md-button>
      <!-- disable until valid -->
      <md-button @click="confirm" class="md-primary" :disabled="value.trim().length < minLength">Add</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { sanitizeInput } from '@/utils/sanitizer';

export default {
  props: {
    visible: Boolean,
    label: String,
    dialogType: String
  },
  data() {
    return {
      internalVisible: this.visible, // local mirror of the prop
      value: ''
    };
  },
  watch: {
    // whenever parent toggles `visible`, update our local copy
    visible(val) {
      this.internalVisible = val;
    },
    // whenever md-dialog changes internalVisible, emit sync back
    internalVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  computed: {
    // define the minimum per type
    minLength() {
      switch (this.dialogType) {
        case 'subject': return 10;
        case 'intro': return 100;
        case 'question': return 250;
        case 'thankyou': return 5;
        case 'prompt': return 200;
        default: return 1;
      }
    },
    maxLength() {
      switch (this.dialogType) {
        case 'subject': return 100;
        case 'intro': return 500;
        case 'question': return 2000;
        case 'thankyou': return 500;
        case 'prompt': return 2000;
        default: return 1;
      }
    }
  },
  methods: {
    confirm() {
      const v = this.value.trim();
      // passed validation!
      this.$emit('confirm', sanitizeInput(v));
      this.value = '';
      this.internalVisible = false;
    },
    cancel() {
      this.$emit('cancel');
      this.value = '';
      this.internalVisible = false;
    }
  }
};
</script>
<style scoped>
.minimum {
  color: #D13525;
  font-size: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AddWizardItem.vue